import React, {useState, useContext, useEffect} from 'react';
import {Field, FieldProps} from 'formik'
import axios from 'axios';
import * as Sentry from '@sentry/react'

import UserContext from '../../contexts/user';
import FormikFieldCustomProps from "../field/formikfieldcustomprops";
import getEncodedImageUrl from '../get-encoded-image';
import AnswerCheckBox from "./answer-checkbox";
import {Label} from "reactstrap";
import MediaCheckbox from "./media-checkbox";

const QuestionImageUpload: React.FC<FormikFieldCustomProps & FieldProps & {
  index:number,
  onDataChange:Function,
  mediaList:any
  activeStatus:boolean,
}> = ({
  field,
  form,
  index,
  onDataChange,
  activeStatus,
  mediaList


}) => {
  const userContext = useContext(UserContext);
  const [uploading, setUploading] = useState(false);
  const [active,setActive]= useState(activeStatus)


  useEffect(()=>{
    if(mediaList[index]?.video !== undefined && mediaList[index].video){
      setActive(false)
    }
  },[mediaList])

  useEffect(() => {
    console.log("setMediaList INIT",mediaList[index],activeStatus);
    if (activeStatus){
      setActive(true)
    }
  },[activeStatus])

  return (
    <div style={{display:'flex' ,marginRight:'5px'}}>
      {/* <pre>{JSON.stringify(field, null, 2)}</pre> */}
      <label htmlFor={field.name} style={{ opacity: uploading ? 0.5 : 1, pointerEvents: uploading ? 'none' : 'all' }}>
      {
        // based on form data show image or placeholder image
        field.value
          ? <img height={80} src={getEncodedImageUrl(field.value, 85, 50, "contain")} alt="" className="uploaded-image-input" />
          : <img src="/icons/upload-image-ico.svg" alt="" className="upload-image-input" />
      }
      </label>
      <input id={field.name} type="file" className="d-none" accept="image/*" onChange={async (file) => {
        if(file.target.files && file.target.files.length === 1) {
          setUploading(true);
          const { name, type } = file.target.files[0];
          try {
            // get public url and signedUrl from backend
            const token = await axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_ENDPOINT}/engagement/s3?objectName=${encodeURIComponent(name)}&contentType=${type}`,
              headers: {
                Authorization: userContext.authHeader
              }
            });
            const { publicUrl, signedUrl } = token.data;
             console.log('debug: signedUrla: ', signedUrl);

            // upload file to s3
            await axios.put(signedUrl, file.target.files[0], {
              headers: {
                'Content-Type': type
              }
            });
            // set values in form to show image
            form.setFieldValue(field.name, publicUrl);
          } catch (e) {
          }
          setUploading(false);
        }
      }} />
      {/*Delete image UI */}
      {field.value ?<div style={{marginLeft:'10px',cursor:'grab',display:'flex',flexDirection:'column'}} >

        <img
            title={"delete"}
            onClick={event => {
              form.setFieldValue(field.name, null);
            }
            }
            src="/icons/trash.svg"
            alt=""
            style={{height:'15px',cursor:'pointer'}}
        />

        <div className={`media-dev`} style={{marginTop:'6px',cursor:'pointer'}}>
          <input
              id ="checkbox_id"
              type="checkbox"
              checked={active}
              onChange={(e)=>{

                // setActive(e.target.checked)}
              }}
          />
          <span className={'media-checkbox'} style={{paddingTop:'10px'}} onClick={(e)=>{
            onDataChange("video",!active);
            setActive(!active);

          }
          }></span>

        </div>


      </div>:""}
    </div>

  );
};


export default QuestionImageUpload;
